import React from 'react';

import useTranslateLpc from '@components/common/hooks/useTranslateLpc';
import Text from '@components/common/Text/Text';
import AuthenticationPageContext from '@components/lpc/Authentication/AuthenticationPageContext';

import css from '../Login.module.scss';

const LostPasswordLink = () => {
    const { t } = useTranslateLpc('lpc-authentication');
    return (
        <AuthenticationPageContext.Consumer>
            {({ setPage, pages }) => (
                <div className={css['lost-password']} onClick={() => setPage(pages.lostPassword)}>
                    <Text variant="caption_02" color="txt-primary">
                        {t('login.lost-password')}
                    </Text>
                </div>
            )}
        </AuthenticationPageContext.Consumer>
    );
};

export default LostPasswordLink;
